import {BaseComponent} from './base-component.js';
import {customElement, property} from 'lit/decorators.js';
import {html, css, CSSResultGroup} from 'lit';

export interface ToggleButtonOption {
  label: string;
  value: string | number | object;
  slug: string; // uniquely IDs each option, required for "selected" feature to work
}

@customElement('il-toggle-button')
export default class ToggleButtonComponent extends BaseComponent {
  @property({type: Array}) options: ToggleButtonOption[] = [];
  @property({type: Object}) selected?: ToggleButtonOption;
  @property({type: Boolean}) disabled = false;
  @property({type: Boolean}) small = false;
  @property({type: Object}) onClick?: (option: ToggleButtonOption) => void;

  // prettier-ignore
  static override styles = [
    BaseComponent.styles,
    css`
      .il-toggle-button {
        display: flex;
      }

      .il-toggle-button il-square-button::part(button) {
        border-radius: 0px;
        width: 100%;
      }

      .il-toggle-button il-square-button:first-child::part(button) {
        border-radius: 6px 0px 0px 6px;
      }

      .il-toggle-button il-square-button:last-child::part(button) {
        border-radius: 0px 6px 6px 0px;
      }

      .il-toggle-button il-square-button {
        display: flex;
        flex: auto;
      }

      .il-toggle-button il-square-button + il-square-button {
        margin-left: -1px;
      }

      .il-toggle-button il-square-button::part(button):hover {
        position: relative;
        z-index: 1;
      }
    `
  ] as CSSResultGroup

  override render() {
    return html`
      <div
        class="
          ${this.baseCSSClass}
          il-toggle-button
        "
        part="toggle-button-content"
        data-test-iliad-toggle-button
      >
        ${this.options.map((option: ToggleButtonOption) => {
          return html`
            <il-square-button
              .label="${option.label}"
              .onClick="${this._onClick.bind(this, option)}"
              .selected="${option.slug === this.selected?.slug}"
              small="${this.small}"
              data-test-iliad-toggle-button-option="${option.slug ||
              option.label}"
            />
          `;
        })}
      </div>
    `;
  }

  /**
   * onClick()
   *
   * Internal click action tha will select the button and trigger the onClick parameter, if present
   */
  private _onClick(option: ToggleButtonOption): void {
    if (this.onClick) {
      this.onClick(option);
    } else {
      this.selected = option;
    }
  }
}
